import { ModuleWithProviders, NgModule } from '@angular/core';

import { CmpsCommonModule } from '../common/common.module';

import { LocationService } from './location.service';

@NgModule({
    imports: [CmpsCommonModule],
})
export class CmpsLocationModule {
    static forRoot(): ModuleWithProviders<CmpsLocationModule> {
        return {
            ngModule: CmpsLocationModule,
            providers: [LocationService],
        };
    }
}
